import React, { useState } from 'react';
import { Button } from '../ui/Button';
import { Search, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/95 backdrop-blur-sm" data-id="element-66">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-67">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/5Ckf69r6uEupqjpPQCFvvo/Black_Logo.png" alt="D2D Guides" className="h-8 w-8 object-contain" data-id="element-69" />
          <span className="font-bold text-slate-900 tracking-tight text-lg" data-id="element-70">
            D2D Guides
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600" data-id="element-71">
          <Link to="/category/crms" className="hover:text-teal-700 transition-colors" data-id="element-72">
            For Businesses
          </Link>
          <Link to="/category/industries" className="hover:text-teal-700 transition-colors" data-id="element-73">
            For Reps
          </Link>
          <Link to="/guides" className="hover:text-teal-700 transition-colors" data-id="element-74">
            Categories
          </Link>
          <Link to="/methodology" className="hover:text-teal-700 transition-colors" data-id="element-75">
            Methodology
          </Link>
          <Link to="/about" className="hover:text-teal-700 transition-colors" data-id="element-76">
            About
          </Link>
        </nav>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-3" data-id="element-77">
          <button className="p-2 text-slate-500 hover:text-slate-900 hover:bg-slate-100 rounded-md transition-colors" data-id="element-78">
            <Search size={20} data-id="element-79" />
          </button>
          <Link to="/guides" data-id="element-80">
            <Button variant="primary" size="sm" data-id="element-81">
              Explore Guides
            </Button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-82">
          {isMenuOpen ? <X size={24} data-id="element-83" /> : <Menu size={24} data-id="element-84" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-4 shadow-lg" data-id="element-85">
          <nav className="flex flex-col gap-4 text-sm font-medium text-slate-600" data-id="element-86">
            <Link to="/category/crms" className="hover:text-teal-700" onClick={() => setIsMenuOpen(false)} data-id="element-87">
              For Businesses
            </Link>
            <Link to="/category/industries" className="hover:text-teal-700" onClick={() => setIsMenuOpen(false)} data-id="element-88">
              For Reps
            </Link>
            <Link to="/guides" className="hover:text-teal-700" onClick={() => setIsMenuOpen(false)} data-id="element-89">
              Categories
            </Link>
            <Link to="/methodology" className="hover:text-teal-700" onClick={() => setIsMenuOpen(false)} data-id="element-90">
              Methodology
            </Link>
            <Link to="/about" className="hover:text-teal-700" onClick={() => setIsMenuOpen(false)} data-id="element-91">
              About
            </Link>
          </nav>
          <div className="pt-4 border-t border-slate-100 flex flex-col gap-3" data-id="element-92">
            <div className="relative" data-id="element-93">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-94" />
              <input type="text" placeholder="Search guides..." className="w-full pl-9 pr-4 py-2 text-sm border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500" data-id="element-95" />
            </div>
            <Link to="/guides" onClick={() => setIsMenuOpen(false)} data-id="element-96">
              <Button variant="primary" className="w-full" data-id="element-97">
                Explore Guides
              </Button>
            </Link>
          </div>
        </div>}
    </header>;
}